<template>
    <div class="adminUserList">
        <Breadcumb :title="$t('report_list')" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card no-body class="cardcontainer">
            <!-- Table controls -->
            <b-card-body>
                <b-table
                        :items="reportsData"
                        :fields="fields"
                        :striped="true"
                        :bordered="true"
                        class="card-table">
                    
                    <template :slot="$t('name')" slot-scope="data">
                        {{data.item.name}}
                    </template>
                    <template slot="Date de l'enquête" slot-scope="data">
                    </template>
                    <template :slot="$t('download_document')" slot-scope="data">
                        <a href="https://keolis-group-survey.kanbios.fr/keolis_affiche.pptx">Télécharger</a>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
    import Breadcumb from '../components/breadcumb'
    import {GET_REPORT_SURVEY_REQUEST} from "../_store/administration/result/actiontypes";
    export default {
        name: 'adminUserList',
        components: { Breadcumb, },
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('report_list'), active: true },
            ];
            this.fields = [
                {
                    key: this.$t('name'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: "Date de l'enquête",
                    sortable: false,
                    tdClass: 'align-middle'
                },
                {
                    key: this.$t('download_document'),
                    sortable: false,
                    tdClass: 'align-middle'
                },
            ];
            this.$store.dispatch(GET_REPORT_SURVEY_REQUEST)
                .then(response => {
                    this.reportsData = response.data.reports
                })
        },
        data() {
            return {
                breadcumbData: [],
                fields: [],
                reportsData: [],
                currentPage: 1
            };
        },
        layout(context) {
            return 'layout';
        },
        methods: {},
    };
</script>
